import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../containers/Users/actions.es6';
import { Container, CssBaseline } from '@material-ui/core'
import EnabledUsersTable from './UsersTable/EnabledUsersTable';
import DisabledUsersTable from './UsersTable/DisabledUsersTable';
import ProductsHeader from '../NewProductList/components/ProductsHeader/ProductsHeader';
import AddUser from './Component/AddUser';
import EditUser from './Component/EditUser';
import DeleteUser from './Component/DeleteUser';
import DisableUser from './Component/DisableUser';
import EnableUser from './Component/Enableuser';
import { PartnersData } from './Component/PartnersData';
import { RolesData } from './Component/RoleData';
import find from 'lodash/find';
import EditRoles from './Component/EditRoles';
import { getAllPartnersRequest } from '../Partners/actions.es6';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import UsersAudit from "./UsersTable/UsersAudit";
import UserAudit from './UsersTable/UserAudit';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}


export class UsersNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddUserDialog: false,
      userToEditRoles: null,
      userToViewAudit: null,
      value: 0,
      usersTabValues: 0,
      openViewAuditDialog: false,
      // active users pagination
      usersPage: 0,
      usersRowsPerPage: 10,
      usersSearch: '',
      // disabled users pagination
      disabledUsersPage: 0,
      disabledUsersRowsPerPage: 10,
      disabledUsersSearch: '',
    };
  }
  componentWillMount() {
    this.props.dispatch(getAllPartnersRequest());
    this.props.dispatch(actions.getUsersRequest({ first: 0, max: 10, search: '' }));
    this.props.dispatch(actions.getRolesRequest());
    this.props.dispatch(actions.getDisabledUsersRequest({ first: 0, max: 10, search: '' }));
  }

  fetchUsers(overrides) {
    const { usersPage, usersRowsPerPage, usersSearch } = Object.assign({}, this.state, overrides || {});
    this.props.dispatch(actions.getUsersRequest({
      first: usersPage * usersRowsPerPage,
      max: usersRowsPerPage,
      search: usersSearch,
    }));
  }

  fetchDisabledUsers(overrides) {
    const { disabledUsersPage, disabledUsersRowsPerPage, disabledUsersSearch } = Object.assign({}, this.state, overrides || {});
    this.props.dispatch(actions.getDisabledUsersRequest({
      first: disabledUsersPage * disabledUsersRowsPerPage,
      max: disabledUsersRowsPerPage,
      search: disabledUsersSearch,
    }));
  }

  componentDidUpdate(prevProps) {
    // if (!this.props.userData.userToDisable && prevProps.userData.userToDisable) {
    //   this.props.dispatch(actions.getDisabledUsersRequest());
    //   this.fetchUsers();
    // }
    // if (!this.props.userData.userToEnable && prevProps.userData.userToEnable) {
    //   this.fetchUsers();
    //   this.props.dispatch(actions.getDisabledUsersRequest());
    // }
  }

  closeAddUserDialog = () => {
    this.setState({ openAddUserDialog: false })
  }
  closeViewAuditDialog = () => {
    this.setState({ openViewAuditDialog: false })
  }

  addUser = (user) => {
    this.props.dispatch(actions.createtUsersRequest(user));
    console.log(user)
  }
  refreshUsers = () => {
    this.fetchUsers();
  }
  editUser = (user) => {
    this.props.dispatch(actions.updateRolesAndPartnersdRequest(user))
  }

  resetUserToEdit = (user) => {
    this.props.dispatch(actions.resetUserToEdit(user))
  }
  setUserToEdit = (user) => {
    this.props.dispatch(actions.setUserToEdit(user))
    this.props.dispatch(actions.getCurrentPartnersRequest(user.id));
  }
  setUserToDelete(user) {
    this.props.dispatch(actions.setUserToDelete(user));
  }
  setUserToDisable(user) {
    this.props.dispatch(actions.setUserToDisable(user));
  }
  setUserToEnable(user) {
    this.props.dispatch(actions.setUserToEnable(user));
  }
  deleteUser = (user) => {
    this.props.dispatch(actions.deleteUsersRequest(user.id));
  }
  disableUser = (user) => {
    this.props.dispatch(actions.disableUserRequest(user.id));
  }

  enableUser = (user) => {
    this.props.dispatch(actions.enableUserRequest(user.id));
  }

  resetUserToEnable = (user) => {
    this.props.dispatch(actions.resetUserToEnable(user))
  }


  resetUserToDelete = (user) => {
    this.props.dispatch(actions.resetUsersToDelete(user))

  }

  resetUserToDisable = (user) => {
    this.props.dispatch(actions.resetUserToDisable(user))
  }

  handleViewAudit = (user) => {

    this.props.dispatch(actions.setUserToViewAuthActivities(user));
    this.setState({ openViewAuditDialog: true })
  }

  readableRoles(allRolesFromKeyCloak) {
    const readableRoles = allRolesFromKeyCloak.map(role => {
      const dummyRole = find(RolesData, { code: role.name })
      if (!dummyRole) return { ...role }
      return { ...role, name: dummyRole.name, code: role.name }
    })
    return readableRoles
  }

  readablePartners(allPartnersFromKeyCloak) {
    const readablePartners = allPartnersFromKeyCloak.map(partnerGuid => {
      const dummyPartner = find(PartnersData, { guid: partnerGuid })
      if (partnerGuid && dummyPartner) {
        return { name: dummyPartner.name, guid: partnerGuid }
      } else {
        return null
      }
    })
    return readablePartners.filter(i => i !== null)
  }

  cleanPartners() {
    return PartnersData.map(partner => {
      return { name: partner.name, guid: partner.guid }
    })
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  handleUsersTabChange = (event, newValue) => {
    this.setState({ usersTabValues: newValue });
  }

  render() {

    const readableRoles = this.readableRoles(this.props.userData.roles)
    const reablePartners = this.cleanPartners()
    const currentReableRoles = this.readableRoles(this.props.userData.currentroles)
    const currentReablePartners = this.readablePartners(this.props.userData.currentPartners)
    console.log("view user auth activity dialog", this.props.userData.openViewAuditDialog)

    return (
      <>
        <CssBaseline />
        <Container maxWidth="lg" style={{ marginTop: "3%" }}>
          <TabPanel value={this.state.value} index={0} >
            <>
                  <ProductsHeader
                    title={"Users Management"}
                    showAddProductDialog={this.state.openAddUserDialog}
                    showAddButton={true}
                    onAddButtonClick={() => { this.setState({ openAddUserDialog: true }) }}
                    showEditButton={false}
                    onEditButtonClick={() => { }}
                  />

                  <Tabs
                    value={this.state.usersTabValues}
                    onChange={this.handleUsersTabChange}
                    aria-label="Vertical tabs example"
                    sx={{ borderRight: 1, borderColor: 'divider', width: "100%" }}
                  >
                    <Tab label="Active Users"  {...a11yProps(0)} />
                    <Tab label="Disabled Users"  {...a11yProps(1)} />
                    <Tab label="User Activity Audit"  {...a11yProps(2)} />
                  </Tabs>

                  <TabPanel value={this.state.usersTabValues} index={0} >
                    <EnabledUsersTable
                      displayEditButton={true}
                      displayDeleteButton={true}
                      setUserToEdit={this.setUserToEdit.bind(this)}
                      setUserToEditRoles={(user) => this.setState({ userToEditRoles: user })}
                      handleViewAudit={this.handleViewAudit.bind(this)}
                      setUserToDelete={this.setUserToDelete.bind(this)}
                      setUserToDisable={this.setUserToDisable.bind(this)}
                      users={this.props.userData.users || []}
                      loader={this.props.userData.loader}
                      page={this.state.usersPage}
                      rowsPerPage={this.state.usersRowsPerPage}
                      hasNextPage={this.props.userData.usersHasNextPage}
                      onPageChange={(newPage) => {
                        this.setState({ usersPage: newPage }, () => this.fetchUsers());
                      }}
                      onRowsPerPageChange={(newSize) => {
                        this.setState({ usersRowsPerPage: newSize, usersPage: 0 }, () => this.fetchUsers());
                      }}
                      onSearch={(term) => {
                        this.setState({ usersSearch: term, usersPage: 0 }, () => this.fetchUsers());
                      }}
                    />

                  </TabPanel>
                  <TabPanel value={this.state.usersTabValues} index={1} >
                    <DisabledUsersTable
                      displayEditButton={true}
                      displayDeleteButton={true}
                      setUserToEdit={this.setUserToEdit.bind(this)}
                      setUserToEditRoles={(user) => this.setState({ userToEditRoles: user })}
                      handleViewAudit={this.handleViewAudit.bind(this)}
                      setUserToDelete={this.setUserToDelete.bind(this)}
                      setUserToEnable={this.setUserToEnable.bind(this)}
                      users={this.props.userData.disabledUsers || []}
                      loader={this.props.userData.loader}
                      page={this.state.disabledUsersPage}
                      rowsPerPage={this.state.disabledUsersRowsPerPage}
                      hasNextPage={this.props.userData.disabledUsersHasNextPage}
                      onPageChange={(newPage) => {
                        this.setState({ disabledUsersPage: newPage }, () => this.fetchDisabledUsers());
                      }}
                      onRowsPerPageChange={(newSize) => {
                        this.setState({ disabledUsersRowsPerPage: newSize, disabledUsersPage: 0 }, () => this.fetchDisabledUsers());
                      }}
                      onSearch={(term) => {
                        this.setState({ disabledUsersSearch: term, disabledUsersPage: 0 }, () => this.fetchDisabledUsers());
                      }}
                    />

                  </TabPanel>
                  <TabPanel value={this.state.usersTabValues} index={2} >
                    <UsersAudit />
                  </TabPanel>
                </>


                <AddUser
                  openAddUserDialog={this.state.openAddUserDialog}
                  closeAddUserDialog={this.closeAddUserDialog.bind(this)}
                  addUser={this.addUser.bind(this)}
                  showAddUserProgressAlert={this.props.userData.createUserLoader}
                  showAddUserSuccessAlert={this.props.userData.createUserSuccess}
                  resetAddUserSuccessAlert={() => {
                    this.props.dispatch(actions.resetCreateUserSuccess())
                    this.props.dispatch(actions.createtUsersRequest())
                  }}
                  refreshUsers={this.refreshUsers.bind(this)}
                  allRoles={readableRoles}
                  allPartners={PartnersData}
                  partners={this.props.partnersData.partners}
                  currentUserRoles={this.props.userData.currentroles}
                  currentUserPartner={this.props.userData.currentpartners}

                  showAddUserErrorAlert={!!this.props.userData.registrationError}
                  addUserError={this.props.userData.registrationError}
                  resetAddUserErrorAlert={() => {
                    this.props.dispatch(actions.createUsersFail(null))
                  }}
                />
                <EditUser
                  user={this.props.userData.userToEdit}
                  editUser={this.editUser.bind(this)}
                  resetUserToEdit={this.resetUserToEdit.bind(this)}

                  showEditUserProgressAlert={this.props.userData.loader}
                  showEditUserSuccessAlert={this.props.userData.editUserSuccess}
                  showEditUserErrorAlert={!!this.props.userData.updateRolesAndPartnersErrors}
                  editUserError={this.props.userData.updateRolesAndPartnersErrors}
                  resetEditUserSuccessAlert={() => {
                    this.props.dispatch(actions.resetEditUserSuccess())
                    this.fetchUsers()
                  }}
                  resetEditUserErrorAlert={() => { this.props.dispatch(actions.resetEditUserError()) }}

                  currentUserReableRoles={currentReableRoles.map(r => r.name)}
                  currentUserPartners={this.props.userData.currentPartners}

                  allRoless={readableRoles.map(r => r.name)}
                  allPartners={this.props.partnersData.partners.map(p => p.guid)}

                  allData={{ readableRoles, reablePartners }}

                />
                <EditRoles
                  user={this.state.userToEditRoles}
                  resetUserToEditRoles={() => this.setState({ userToEditRoles: null })}

                  currentUserReableRoles={currentReableRoles.map(r => r.name)}
                  currentUserPartners={currentReablePartners.map(p => p.name)}

                  allRoless={readableRoles.map(r => r.name)}
                  allPartners={reablePartners.map(p => p.name)}

                  allData={{ readableRoles, reablePartners }}

                />

                <DeleteUser
                  user={this.props.userData.userToDelete}
                  deleteUser={this.deleteUser.bind(this)}
                  resetUserToDelete={this.resetUserToDelete.bind(this)}
                  showDeleteUserProgressAlert={this.props.userData.hardDeleteUserLoader}
                  showDeleteUserSuccessAlert={this.props.userData.hardDeleteUserSuccess}
                  showDeleteUserErrorAlert={!!this.props.userData.deleteUserErrors}
                  deleteUserError={this.props.userData.deleteUserErrors}

                  resetDeleteUserSuccessAlert={() => {
                    this.props.dispatch(actions.resetHardDeleteUserSuccess())
                    this.fetchUsers()
                  }}
                  resetDeleteUserErrorAlert={() => { this.props.dispatch(actions.resetHardDeleteUserError()) }}
                />
                <DisableUser
                  user={this.props.userData.userToDisable}
                  disableUser={this.disableUser.bind(this)}
                  resetUserToDisable={this.resetUserToDisable.bind(this)}
                  showDisableUserProgressAlert={this.props.userData.disableUserLoader}
                  showDisableUserSuccessAlert={this.props.userData.disableUserSuccess}
                  showDisableUserErrorAlert={!!this.props.userData.disableUserErrors}
                  disableUserError={this.props.userData.disableUserErrors}
                  resetDisableUserSuccessAlert={() => {
                    this.props.dispatch(actions.resetDisableUserSuccess())
                    this.fetchUsers()
                  }}
                  resetDisableUserErrorAlert={() => { this.props.dispatch(actions.resetDisableUserError()) }}
                />
                <EnableUser
                  user={this.props.userData.userToEnable}
                  enableUser={this.enableUser.bind(this)}
                  resetUserToEnable={this.resetUserToEnable.bind(this)}
                  showEnableUserProgressAlert={this.props.userData.enableUserLoader}
                  showEnableUserSuccessAlert={this.props.userData.enableUserSuccess}
                  showEnableUserErrorAlert={!!this.props.userData.enableUserErrors}
                  enableUserError={this.props.userData.enableUserErrors}
                  resetEnableUserSuccessAlert={() => {
                    this.props.dispatch(actions.resetEnableUserSuccess())
                    this.fetchUsers()
                  }}
                  resetEnableUserErrorAlert={() => { this.props.dispatch(actions.resetEnableUserError()) }}
                />
                <UserAudit
                  user={this.props.userData.userToViewAudit}
                  openViewAuditDialog={this.state.openViewAuditDialog}
                  closeViewAuditDialog={this.closeViewAuditDialog.bind(this)}
                />

              </TabPanel>

          </Container>
      </>
    )
  }
}
export default connect(state => ({
  userData: state.userAdmin,
  globalData: state.global,
  partnersData: state.partners,
}))(UsersNew);